import { datadogLogs } from '@datadog/browser-logs';
import cloneDeepWith from 'lodash/cloneDeepWith';
import { trace } from '../configuration/setup/trace';

const isProd = import.meta.env.PROD;

const sensitiveQueryParameter = ['access_token', 'code', 'id_token', 'session_state', 'state'];
const sensitiveQueryParameterRegex = new RegExp(`([?&])(${sensitiveQueryParameter.join('|')})=([^&]*)`, 'gu');

export const sensitiveQueryParameterReplacer = (val: unknown, key?: unknown) => {
    if (typeof key === 'string' && sensitiveQueryParameter.includes(key) && typeof val === 'string') {
        return 'REDACTED';
    }

    if (typeof val === 'string') {
        return val.replace(sensitiveQueryParameterRegex, '$1$2=REDACTED');
    }
};

export const configureDatadogLogging = () => {
    if (isProd) {
        datadogLogs.init({
            clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
            forwardErrorsToLogs: false,
            forwardConsoleLogs: ['error'],
            site: import.meta.env.VITE_DATADOG_SITE_URL,
            sessionSampleRate: 100,
            version: APP_VERSION,
            service: import.meta.env.VITE_DATADOG_SERVICE_NAME,
            env: 'prod',
            beforeSend: (obj: object) => cloneDeepWith(obj, sensitiveQueryParameterReplacer),
        });
        datadogLogs.setGlobalContextProperty('account_id', import.meta.env.VITE_AWS_ACCOUNT_ID);
        datadogLogs.setGlobalContextProperty('team', import.meta.env.VITE_TEAM_IDENTIFIER);
        datadogLogs.setGlobalContextProperty('team_identifier', import.meta.env.VITE_TEAM_IDENTIFIER);
    }
};

const errorToMessage = (error: unknown) => {
    if (error instanceof Error && error.message) {
        return error.message;
    }
    if (typeof error === 'string') {
        return error;
    }
    return 'Unexpected error';
};

export const reportErrorToDatadog = (error: unknown, context?: Record<string, unknown>) => {
    if (isProd) {
        datadogLogs.logger.error(errorToMessage(error), {
            error,
            ...context,
        });
        return;
    }

    trace('error', { error, ...context });
};
